import { render, staticRenderFns } from "./batteryBunker.vue?vue&type=template&id=63ef30de&"
import script from "./batteryBunker.vue?vue&type=script&lang=js&"
export * from "./batteryBunker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ef30de')) {
      api.createRecord('63ef30de', component.options)
    } else {
      api.reload('63ef30de', component.options)
    }
    module.hot.accept("./batteryBunker.vue?vue&type=template&id=63ef30de&", function () {
      api.rerender('63ef30de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/batteryBunker/batteryBunker.vue"
export default component.exports